<template>
  <div v-if="loading">
    <div id="container"></div>
    <div id="loading-bar-bg">
      <div id="loading-bar-content">
        <span>Идет обработка. Ждите...</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: "PanelLoading",
    computed: {
      ...mapGetters(['loading']),
    },
  }
</script>

<style scoped>
  #container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: url(../../../assets/ui-bg_diagonals-thick_8_333333_40x40.png) repeat;
    opacity: 0.5;
  }

  #loading-bar-bg {
    border: 1px solid #dddddd;
    border-radius: 6px;
    background: #f2f5f7 url(../../../assets/ui-bg_highlight-hard_100_f2f5f7_1x100.png) 50% top repeat-x;
    color: #362b36;
    position: fixed;
    min-width: 600px;
    min-height: 50px;
    top: 50%;
    left: 50%;
    margin-top: -11px;
    margin-left: -300px;
  }

  #loading-bar-content {
    border: 1px solid #2694e8;
    border-radius: 6px;
    background: #3baae3 url(../../../assets/ui-bg_glass_50_3baae3_1x400.png) 50% 50% repeat;
    max-width: 596px;
    min-height: 46px;
    margin: 2px auto;
    overflow: hidden;
  }

  span {
    display: table;
    margin: 0 auto;
    text-align: center;
    vertical-align: middle;
    font-size: 18px;
    font-weight: bold;
    font-family: "Lucida Grande", "Lucida Sans", Arial, sans-serif;
    color: #ffffff;
    transform: translateY(50%);
  }
</style>

